import {Injectable} from '@angular/core';
import {IFullGraphData, IRestrictionStepOrder} from '../models/graph-kn.model-interfaces';
import {TranslateService} from '@ngx-translate/core';
import {ContractStepModel} from '../../../models/contract.model';
import {CONTRACT_LAYER_ID} from '../models/graph-kn.cm-api-models';
import {Group} from 'konva/lib/Group';
import {GraphKnHelperService} from './graph-kn.helpers.service';

@Injectable({
    providedIn: 'root'
})
export class GraphKnRestrictionsService {
    public stepsToAdd: ContractStepModel[] = [];
    private restrictionsPerContract: Map<string, IRestrictionStepOrder[]> = new Map();

    constructor(
        private translateService: TranslateService,
        private knHelperService: GraphKnHelperService
    ) {
    }

    prepareRestrictions(graphData: IFullGraphData) {
        let restrictions: IRestrictionStepOrder[] = [];
        let creaditLetters: { payer_guid: string, credit_letter_guid: string, guid: string } [] = [];
        graphData.projects ? creaditLetters = graphData.projects
            .filter(project => project.credit_letter_guid)
            .map(project => {
                    return {
                        payer_guid: project.project.guid,
                        credit_letter_guid: project.credit_letter_guid,
                        guid: graphData.nodes.find(el => el.contract_step_data?.target?.target_key === project.credit_letter_guid)?.id || ''
                    }
                }
            ) : null;
        creaditLetters.forEach(letter => {
            let multi_paymentsGuids = graphData.nodes
                .filter(el => el.contract_step_data?.target_type === 'multi_payment')
                .map(elmp => elmp.contract_step_data?.multi_payment_data?.filter(mp => mp.payer_guid === letter.payer_guid)
                    .map(() => elmp.contract_step_data?.guid)) || [];
            let paymentsGuids = graphData.nodes
                .filter(el => el.contract_step_data?.target_type === 'payment' && el.contract_step_data.payment_data?.payer_guid === letter.payer_guid)
                .map(el => el.contract_step_data?.guid) || []
            let allpaymentsGuid = [...multi_paymentsGuids.flat(), ...paymentsGuids]

            restrictions.push({
                guidStep: letter.guid,
                typeRestriction: 'before',
                guidsLinkedSteps: graphData.nodes
                    .filter(step => ['multi_payment', 'payment'].includes(step.contract_step_data?.target_type || 'none') && allpaymentsGuid.includes(step.contract_step_data?.guid)).map(el => el.id)
            })
            restrictions.filter(rs => rs.typeRestriction === 'before').forEach(res => {
                let paymentSteps = res.guidsLinkedSteps.map(ls => {
                    return {
                        guidStep: ls,
                        typeRestriction: 'after' as 'after' | 'before',
                        guidsLinkedSteps: [res.guidStep]
                    }
                })
                restrictions.push(...paymentSteps)
            })
        })
        this.restrictionsPerContract.set(CONTRACT_LAYER_ID, restrictions)
    }

    checkResctrictionDrag(swappingGroup: {
        guid: string,
        index: number
    }[], contractGuid: string, nodeGroupsEnv: Group[]): {
        blocked: boolean,
        msg: string,
        restrictionGroup: IRestrictionStepOrder
    } {
        let proposedStepOrder = [...this.knHelperService.swapTwoElements(nodeGroupsEnv, swappingGroup[0].index, swappingGroup[1].index)]
        let restrictionGroup: IRestrictionStepOrder[] = []
        let blocked = swappingGroup.some((group, i) => {
          let restrictions = this.restrictionsPerContract.get(contractGuid)?.filter(rs => rs.guidStep === group.guid)
          let sliceIndex = i === 0 ? swappingGroup[1].index : swappingGroup[0].index
          let groupViolation = restrictions?.some(resGroup => {
            let violation = false
                let partOfGroupArray = resGroup.typeRestriction === 'before' ? proposedStepOrder.slice(sliceIndex+1, proposedStepOrder.length ) : proposedStepOrder.slice(0, sliceIndex)
                violation = partOfGroupArray.filter(rs => resGroup.guidsLinkedSteps.includes(rs.attrs.id)).length !== resGroup.guidsLinkedSteps.length;
                restrictionGroup = restrictions
                return violation === true
            })
            return groupViolation === true
        })
        return {
            blocked: blocked,
            msg: this.translateService.instant('ALERTS.CREDIT_LETTER_BEFORE_PAYMENT'),
            restrictionGroup: restrictionGroup[0]
        }
    }
}